import type { FC } from 'react';
import { COLOR_BLACK } from 'shared/helpers/colors';
import useAuth from 'shared/hooks/useAuth';
import type { FlattenSimpleInterpolation } from 'styled-components';

import styled from 'styled-components';

const Container = styled.div<{ css?: FlattenSimpleInterpolation }>`
  ${(props) => props.css}
`;

const Label = styled.label<{ css?: FlattenSimpleInterpolation }>`
  cursor: pointer;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 800;
  font-size: 1.4rem;
  line-height: 1.8rem;
  color: ${COLOR_BLACK};
  position: relative;
  padding-left: 3rem;

  ${(props) => props.css}
`;

const Input = styled.input<{ backgroundColor: string }>`
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;

  &:checked ~ .checkmark {
    background-color: ${(props) => props.backgroundColor};
  }

  &:checked ~ .checkmark::after {
    display: block;
  }
`;

const Span = styled.span<{ css?: FlattenSimpleInterpolation }>`
  position: absolute;
  top: 0;
  left: 0;
  height: 2rem;
  width: 2rem;
  border: 1px solid ${COLOR_BLACK};
  border-radius: 5px;

  &::after {
    content: '';
    position: absolute;
    display: none;
    left: 6px;
    top: 1px;
    width: 7px;
    height: 1.2rem;
    border: solid ${COLOR_BLACK};
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);

    @media only screen and (max-width: 56.25em) {
      left: 2px;
    }
  }

  ${(props) => props.css}
`;

interface Props {
  id: string;
  label: string | React.ReactNode;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  readOnly?: boolean;
  isDisabled?: boolean;
  onCheckboxClick?: (v: boolean) => void;
  cssLabel?: FlattenSimpleInterpolation;
  cssContainer?: FlattenSimpleInterpolation;
  cssCheckbox?: FlattenSimpleInterpolation;
}

const TextCheckbox: FC<Props> = ({
  id,
  label,
  onChange,
  checked,
  readOnly,
  isDisabled,
  onCheckboxClick,
  cssLabel,
  cssContainer,
  cssCheckbox
}) => {
  const { whiteLabelBranding } = useAuth();

  return (
    <div>
      <Container css={cssContainer}>
        <Label css={cssLabel} style={{ opacity: isDisabled ? 0.5 : 1 }} htmlFor={id}>
          {label}
          <Input
            type="checkbox"
            id={id}
            onChange={onCheckboxClick ? undefined : onChange}
            checked={checked}
            readOnly={!!readOnly}
            required
            disabled={isDisabled}
            backgroundColor={whiteLabelBranding.color1}
          />
          <Span
            onClick={() => onCheckboxClick?.(!checked)}
            css={cssCheckbox}
            className="checkmark"
          />
        </Label>
      </Container>
    </div>
  );
};

export default TextCheckbox;
